<!-- 开题报告 -->
<template>
  <svg v-if="modelValue == 0" class="notStarted" viewBox="0 0 35.2 35.59">
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="27" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="27" rx="13.61" ry="6.79" />
        <path
          class="cls-3"
          d="M15.77,28.12H7a1.68,1.68,0,0,1-1.68-1.68V2.52A1.68,1.68,0,0,1,7,.84H26.75a1.68,1.68,0,0,1,1.68,1.68V12.63"
        />
        <line class="cls-3" x1="8.52" y1="14.08" x2="17.42" y2="14.08" />
        <line class="cls-3" x1="8.52" y1="8.09" x2="20.59" y2="8.09" />
        <path
          class="cls-3"
          d="M21.08,27.86a3,3,0,0,1-.52,0,2.88,2.88,0,0,1,.21-5.69"
        />
        <path class="cls-3" d="M21,22a3.65,3.65,0,0,1,7.3,0" />
        <path
          class="cls-3"
          d="M28.28,22.12a2.87,2.87,0,0,1,.35,5.71,3.4,3.4,0,0,1-.45,0"
        />
        <line class="cls-3" x1="24.21" y1="23.99" x2="24.21" y2="28.17" />
        <path
          class="cls-3"
          d="M22.49,24.75,24,23.22a.16.16,0,0,1,.24,0l1.56,1.56"
        />
      </g>
    </g>
  </svg>
  <svg v-else-if="modelValue == 1" class="inProgress" viewBox="0 0 35.2 35.89">
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="27.29" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="27.29" rx="13.61" ry="6.79" />
        <path
          class="cls-3"
          d="M15.58,28.18H6.82a1.68,1.68,0,0,1-1.68-1.67V2.58A1.68,1.68,0,0,1,6.82.9H26.56a1.68,1.68,0,0,1,1.68,1.68V12.69"
        />
        <line class="cls-3" x1="8.33" y1="14.15" x2="17.23" y2="14.15" />
        <line class="cls-3" x1="8.33" y1="8.15" x2="20.41" y2="8.15" />
        <path
          class="cls-3"
          d="M20.89,27.92a3,3,0,0,1-.52,0,2.88,2.88,0,0,1,.21-5.69"
        />
        <path class="cls-3" d="M20.76,22.1a3.65,3.65,0,1,1,7.3,0" />
        <path
          class="cls-3"
          d="M28.09,22.18a2.87,2.87,0,0,1,.35,5.71,3.4,3.4,0,0,1-.45,0"
        />
        <line class="cls-3" x1="24.02" y1="24.05" x2="24.02" y2="28.23" />
        <path
          class="cls-3"
          d="M22.3,24.82l1.54-1.54a.16.16,0,0,1,.24,0l1.56,1.56"
        />
      </g>
    </g>
  </svg>
  <svg v-else viewBox="0 0 35.2 35.77">
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="27.17" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="27.17" rx="13.61" ry="6.79" />
        <path
          class="cls-3"
          d="M15.67,28H7a1.65,1.65,0,0,1-1.65-1.66V2.76A1.66,1.66,0,0,1,7,1.1h19.5a1.67,1.67,0,0,1,1.66,1.66v10"
        />
        <line class="cls-4" x1="8.5" y1="12.72" x2="17.29" y2="12.72" />
        <line class="cls-5" x1="8.5" y1="6.79" x2="20.43" y2="6.79" />
        <path
          class="cls-4"
          d="M20.9,27.79a2.73,2.73,0,0,1-.5-.05,2.83,2.83,0,0,1,.2-5.61"
        />
        <path class="cls-6" d="M20.77,22A3.61,3.61,0,0,1,28,22" />
        <path
          class="cls-4"
          d="M28,22.11a2.84,2.84,0,0,1,.35,5.64,3.42,3.42,0,0,1-.45,0"
        />
        <line class="cls-7" x1="24" y1="23.96" x2="24" y2="28.09" />
        <path
          class="cls-7"
          d="M22.3,24.72l1.52-1.52a.17.17,0,0,1,.23,0l1.54,1.54"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts" setup>
  withDefaults(
    defineProps<{
      /** 任务执行状态 */
      modelValue: number;
    }>(),
    // 默认值
    { modelValue: 0 }
  );
</script>
<style lang="scss" scoped>
  // 未开始
  .notStarted {
    .cls-1 {
      fill: #f0f7f7;
    }
    .cls-2 {
      fill: #d7e2e2;
    }
    .cls-3 {
      fill: none;
      stroke: #9a9b9b;
      stroke-linecap: round;
      stroke-miterlimit: 10;
      stroke-width: 1.68px;
    }
  }
  // 进行中
  .inProgress {
    .cls-1 {
      fill: #f4e4d4;
    }
    .cls-2 {
      fill: #efd0a3;
    }
    .cls-3 {
      fill: none;
      stroke: #ed9c24;
      stroke-linecap: round;
      stroke-miterlimit: 10;
      stroke-width: 1.8px;
    }
  }
  // 已完成
  .completed {
    .cls-1 {
      fill: #d5ebe9;
    }
    .cls-2 {
      fill: #b8ded9;
    }
    .cls-3,
    .cls-4,
    .cls-5,
    .cls-6,
    .cls-7 {
      fill: none;
      stroke: #27aa8e;
      stroke-linecap: round;
      stroke-miterlimit: 10;
    }
    .cls-3 {
      stroke-width: 2.21px;
    }
    .cls-4 {
      stroke-width: 1.98px;
    }
    .cls-5 {
      stroke-width: 1.79px;
    }
    .cls-6 {
      stroke-width: 1.98px;
    }
    .cls-7 {
      stroke-width: 1.1px;
    }
  }
</style>
